<!--
  @Description 数据处理编辑
  @Date 2022-10-20
  @Author liufu
-->
<template>
  <vxe-modal
    v-model="isShow"
    size="mini"
    width="80%"
    height="80%"
    @show="showWindows"
    @close="closeWindows"
    :title="`[${modalType}] 数据处理`"
  >
    <!-- 编辑区域 -->
    <div class="edit-dv">
      <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
        <!-- 第一行 -->
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="模块" prop="groupName">
              <el-select
                clearable
                v-model="form.groupName"
                :disabled="!!form.vuePath || !$parent.Authority.edit || form.handlerID > 0"
                :placeholder="placeholderConfig.select"
              >
                <!-- @change="groupNameChange" -->
                <el-option
                  v-for="(i, index) of ComBoxItems.groupName"
                  :key="i + index + ''"
                  :label="i"
                  :value="i"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="菜单" prop="vuePath">
              <el-select
                clearable
                v-model="form.vuePath"
                @change="vuePathChange"
                :placeholder="placeholderConfig.select"
                filterable
                :disabled="!$parent.Authority.edit || form.handlerID > 0"
              >
                <el-option
                  v-for="(i, index) of ComBoxItems.vuePath"
                  :key="i.vuePath + index + ''"
                  :label="i.vuePath"
                  :value="i.vuePath"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第二行 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="数据处理描述" prop="requirementDesc">
              <el-input
                type="textarea"
                :rows="id > 0 ? 8 : 15"
                v-model="form.requirementDesc"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
                :disabled="!$parent.Authority.edit || form.handlerID > 0"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <div v-show="id > 0">
          <YKDivider>登记信息</YKDivider>
          <!-- 第三行 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="登记单位" prop="userCompany">
                <el-input
                  v-model="form.userCompany"
                  autocomplete="off"
                  :placeholder="placeholderConfig.relation"
                  disabled
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="登记人员" prop="recorder">
                <el-input
                  v-model="form.recorder"
                  autocomplete="off"
                  :placeholder="placeholderConfig.relation"
                  disabled
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="登记日期" prop="recordDate">
                <el-date-picker
                  v-model="form.recordDate"
                  v-date
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="placeholderConfig.relation"
                  disabled
                ></el-date-picker>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>

          <YKDivider>处理信息</YKDivider>
          <!-- 第四行 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="处理结果" prop="handleResult">
                <el-input
                  v-model="form.handleResult"
                  autocomplete="off"
                  :placeholder="placeholderConfig.relation"
                  disabled
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="处理人员" prop="handler">
                <el-input
                  v-model="form.handler"
                  autocomplete="off"
                  :placeholder="placeholderConfig.relation"
                  disabled
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="处理日期" prop="handleTime">
                <el-date-picker
                  v-model="form.handleTime"
                  v-date
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="placeholderConfig.relation"
                  disabled
                ></el-date-picker>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="完成处理日期" prop="issuedTime">
                <el-date-picker
                  v-model="form.issuedTime"
                  type="date"
                  v-date
                  value-format="yyyy-MM-dd"
                  :placeholder="placeholderConfig.relation"
                  disabled
                ></el-date-picker>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>

          <YKDivider>评价信息</YKDivider>
          <!-- 第五行 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="评价" prop="assessResult">
                <el-input
                  v-model="form.assessResult"
                  autocomplete="off"
                  :placeholder="placeholderConfig.relation"
                  disabled
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="评价人" prop="assessor">
                <el-input
                  v-model="form.assessor"
                  autocomplete="off"
                  :placeholder="placeholderConfig.relation"
                  disabled
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="评价日期" prop="assessTime">
                <el-date-picker
                  v-model="form.assessTime"
                  v-date
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="placeholderConfig.relation"
                  disabled
                ></el-date-picker>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="评价说明" prop="assessNote">
                <el-input
                  v-model="form.assessNote"
                  autocomplete="off"
                  :placeholder="placeholderConfig.relation"
                  disabled
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>

    <!-- 间隔槽（内含保存按钮） -->
    <div class="gap-dv">
      <el-button
        size="small"
        type="primary"
        style="width: 150px"
        :disabled="!$parent.Authority.edit || form.handlerID > 0"
        @click="save()"
        >保存</el-button
      >
      <el-button size="small" type="primary" style="width: 150px" :disabled="this.id <= 0" @click="handleAttachment()"
        >附件</el-button
      >
      <el-button
        size="small"
        type="danger"
        style="width: 150px"
        :disabled="!$parent.Authority.edit || form.handlerID > 0"
        @click="del()"
        >删除</el-button
      >
    </div>
    <!-- 附件 -->
    <AttachmentDrawer
      ref="AttachmentDrawer"
      :attachmentDisplay.sync="attachmentDisplay"
      :parentObj="this"
      :edit="true"
      :keyValue="id"
    ></AttachmentDrawer>
  </vxe-modal>
</template>

<script>
import AttachmentDrawer from './AttachmentDrawer.vue'
export default {
  name: 'instructionEdit',
  components: { AttachmentDrawer },
  props: {},
  data() {
    return {
      id: -1,
      // 窗口类型
      modalType: '新增',
      // 下拉框
      ComBoxItems: {
        AllItems: [],
        groupName: [],
        vuePath: []
      },
      // 弹窗是否打开
      isShow: false,
      form: {
        productionType: '',
        groupName: '',
        vuePath: '',
        userCompany: '',
        recorderID: '',
        recorder: '',
        recordDate: '',
        requirementDesc: '',
        handleResult: '',
        handlerID: '',
        handler: '',
        handleTime: '',
        issuedTime: '',
        assessResult: '',
        assessNote: '',
        assessorID: '',
        assessor: '',
        assessTime: ''
      },
      rules: {
        groupName: [{ required: true, message: '请选择模块', trigger: 'change' }],
        vuePath: [{ required: true, message: '请选择菜单', trigger: 'change' }],
        requirementDesc: [
          { required: true, message: '请输入数据处理描述', trigger: 'change' },
          {
            min: 0,
            max: 1000,
            message: '长度应在 0 到 1000 个字符',
            trigger: 'change'
          }
        ]
      },
      // 是否打开附件窗口
      attachmentDisplay: false
    }
  },
  methods: {
    // 附件
    handleAttachment() {
      console.log('附件')
      this.attachmentDisplay = true
      this.$refs.AttachmentDrawer.formVisible = true
    },
    // 初始化单据
    initForm() {
      this.form = {
        productionType: '',
        groupName: '',
        vuePath: '',
        userCompany: '',
        recorderID: '',
        recorder: '',
        recordDate: '',
        requirementDesc: '',
        handleResult: '',
        handlerID: '',
        handler: '',
        handleTime: '',
        issuedTime: '',
        assessResult: '',
        assessNote: '',
        assessorID: '',
        assessor: '',
        assessTime: ''
      }
    },
    // 获取单据数据
    async getFormData() {
      const { data: res } = await this.$http.get('/Bugs/YKDataProcessing', {
        params: {
          id: this.id
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.form = res.data
    },
    // 绑定下拉框
    async BindComBox() {
      this.ComBoxItems.AllItems = []
      this.ComBoxItems.groupName = []
      const { data: res } = await this.$http.post(`/Bugs/YKBug/select?productionType=${this.$store.state.productType}`)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.ComBoxItems.AllItems = res.data
      this.groupNameChange()
      // 过滤出模块下拉框
      for (let item of res.data) {
        if (!this.ComBoxItems.groupName.includes(item.groupName)) {
          this.ComBoxItems.groupName.push(item.groupName)
        }
      }
    },
    // 当模块菜单变化时
    groupNameChange() {
      if (this.form.groupName) {
        this.ComBoxItems.vuePath = this.ComBoxItems.AllItems.filter(item => {
          return item.groupName === this.form.groupName
        })
      } else {
        this.ComBoxItems.vuePath = this.ComBoxItems.AllItems
      }
    },
    // 当菜单变化时 (预留)
    async vuePathChange(e) {
      if (!this.form.vuePath) {
        return
      }
      // 根据菜单查找模块
      if (!this.form.groupName) {
        for (let item of this.ComBoxItems.AllItems) {
          if (item.vuePath === e) {
            this.form.groupName = item.groupName
            break
          }
        }
      }
      // 获取是否有别的厂家提的，如果有跳转过去
      const { data: res } = await this.$http.get('/Bugs/YKDataProcessing/history', {
        params: {
          productionType: this.$store.state.productType,
          groupName: this.form.groupName,
          vuePath: this.form.vuePath
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      if (res.data > 0) {
        this.id = res.data
        this.modalType = '修改'
        this.getFormData()
      }
    },
    // 提交变更
    async save() {
      const isCanSave = await this.validForm()
      if (!isCanSave) return

      if (this.id > 0) {
        await this.update()
      } else {
        await this.add()
      }
    },
    // 新增
    async add() {
      const { data: res } = await this.$http.post('/Bugs/YKDataProcessing', {
        productionType: this.$store.state.productType,
        groupName: this.form.groupName,
        vuePath: this.form.vuePath,
        requirementDesc: this.form.requirementDesc,
        userCompany: this.$store.state.userInfo.company
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.modalType = '修改'
      this.$message.success('新增成功!')
      this.id = res.data
      this.getFormData()
    },
    // 修改
    async update() {
      const { data: res } = await this.$http.put('/Bugs/YKDataProcessing', {
        id: this.id,
        productionType: this.$store.state.productType,
        groupName: this.form.groupName,
        vuePath: this.form.vuePath,
        requirementDesc: this.form.requirementDesc,
        userCompany: this.$store.state.userInfo.company
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('修改成功!')
    },
    // 删除
    del() {
      const that = this
      this.$confirm('此操作将永久删除该单据, 是否继续?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await that.$http.delete('/Bugs/YKDataProcessing', {
          data: {
            id: that.id,
            logStr: `[${this.form.productionType}]${this.form.groupName}-${this.form.vuePath}`,
            effectCondition: that.$parent.Authority.alEffectCondition,
            empower: []
          }
        })
        if (!res.isSuccess) {
          that.$message.error(res.errorMessage)
          return false
        }
        that.$message.success('删除成功!')
        that.closeModal()
      })
    },
    // 监听模态框开启
    async showWindows() {
      this.BindComBox()
      // this.$refs['FormRef'].resetFields()
      this.initForm()
      if (this.id > 0) {
        this.getFormData()
      }
      this.$nextTick(() => {
        this.$refs['FormRef'].clearValidate()
      })
    },
    // 监听模态框关闭
    async closeWindows() {
      await this.$parent.refresh()
    },
    // 校验表单
    async validForm() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      if (!flag) {
        this.$message.error('请正确填写信息')
      }
      return flag
    },
    async closeModal() {
      this.isShow = false
      await this.$parent.refresh()
    }
  },
  computed: {
    // 当前登录用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    }
  },
  watch: {
    'form.groupName': {
      handler() {
        this.groupNameChange()
      }
    }
  }
}
</script>

<style lang="less" scoped>
@history-dv-height: 200px;
@all-dv-width: 98%;
// 编辑说明和历史说明之间的间隔
@dv-margin: 10px;
// 间隔槽总高度 = 高度 + margin
@gap-margin: 10px;
@gap-height: 30px;
@gap-padding-bottom: 10px;
.edit-dv {
  width: @all-dv-width;
  margin: 0 auto;
  height: calc(
    // dv-margin: 需要乘的数值 = 整体区块数量 + 1（如加了一个 gap-dv，则需要 + 1）
    100% - @dv-margin*4 - @gap-height - @gap-margin
  );
  overflow-y: scroll;
  overflow-x: hidden;
}

.edit-dv::-webkit-scrollbar {
  display: none;
}

.gap-dv {
  width: 100%;
  height: @gap-height;
  margin: @gap-margin 0;
  padding-bottom: @gap-padding-bottom;
  // border-bottom: 1px solid #f2f3f5;
  .fl;

  .btn {
    margin: 0 10px;
    width: 180px;
    height: 30px;
    font-size: 14px;
    border-radius: 5px;
    outline: none;
    border: none;
    transition: @normal-transition;
  }

  .save-btn {
    background-color: @primary-color;
    color: @text-color;
  }

  .add-btn {
    width: 100px;
    color: #666;
  }

  .del-btn {
    width: 100px;
    background-color: #ff8b8b;
    color: #fff;
  }
}

.btn-dv-prohibit {
  // cursor: not-allowed;
  transition: none !important;
  opacity: 0.5 !important;
  // color: #c0c4cc;
  // border-color: #ebeef5;
  // background-color: #f2f3f5;
}
.btn-dv-prohibit:hover {
  cursor: not-allowed !important;
  opacity: 0.5 !important;
}

.history-dv {
  width: @all-dv-width;
  height: @history-dv-height;
  margin: 10px auto;
  // background-color: #ffcc66;
  overflow-y: scroll;
  box-sizing: border-box;
  font-size: 14px;

  .history-title {
    font-size: 16px;
    font-weight: bold;
    color: @able-color;
  }

  .history-list-dv {
    width: 97%;
    padding: @dv-margin auto;

    .history-list-item {
      margin: 6px 0;
    }
  }
}

.el-row {
  margin-bottom: 12px !important;
}
</style>
